export default __webpack_public_path__ + "static/media/litecampus-pin.7e54a014.svg";